import React from "react";
import { FormRuntime } from "../FormRuntime";

import {
    getGridForm,
    getOneControlsGrid,
    getOverridedBackgroundGrid,
    getOverridedBorderGrid,
    getOverridedInnerMargin,
    getRowHeightGridForm,
} from "./Testing/TestDataSetup";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const ContaineGridStories = [
    new StoryNode(
        () => {
            let ui = getGridForm();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "Layout"
    ),
    new StoryNode(
        () => {
            let ui = getOneControlsGrid();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "One Control"
    ),
    new StoryNode(
        () => {
            let ui = getOverridedBorderGrid();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "Overide Border"
    ),
    new StoryNode(
        () => {
            let ui = getOverridedBackgroundGrid();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "Override Background"
    ),
    new StoryNode(
        () => {
            let ui = getOverridedInnerMargin();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "Override Inner Margin"
    ),
    new StoryNode(
        () => {
            let ui = getRowHeightGridForm();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Grid Container",
        "Row Height"
    ),
];
